import { Button } from "../../components/forms/Form";
import "./CreateStoreModal.css";
const formInput = (props) => {
  return (
    <input
      {...props.value}
      placeholder={props.placeholder}
      defaultValue={props.initialValue}
      type="text"
      className="create-store-form-input form-item"
      onChange={(event) =>
        props.handleChangeInput(props.target, event.target.value)
      }
    ></input>
  );
};
export const ModifyStoreForm = (props) => {
  return (
    <div className="create-store-form">
      {formInput({
        placeholder: "Nome",
        initialValue: props.editingStore.siteName,
        target: "siteName",
        handleChangeInput: props.handleChangeInput,
      })}
      {/* {props.error && (
        <p style={{ color: "red", fontWeight: "600" }}>
          {props.error.response.data.message}
        </p>
      )} */}

      {formInput({
        placeholder: "URL",
        initialValue: props.editingStore.siteHostname,
        target: "siteHostname",
        handleChangeInput: props.handleChangeInput,
      })}

      {formInput({
        placeholder: "Azienda",
        initialValue: props.editingStore.siteCompanyName,
        target: "siteCompanyName",
        handleChangeInput: props.handleChangeInput,
      })}

      <div className="create-store-button-container">
        <Button
          text={"ANNULLA"}
          className={"exit-button"}
          handleSubmit={() => props.togglePopUp()}
        />
        <Button
          text={"MODIFICA"}
          loading={props.loading}
          handleSubmit={props.handleSubmit}
          disabled={props.disabled()}
        />
      </div>
    </div>
  );
};
